<template>
  <div>
    <v-container fluid>
      <v-row align="center" justify="space-between" class="font-weight-black">
        <v-col cols="12" sm="11">
          <v-breadcrumbs :items="breadcrumbs" divider="/" v-if="!omiteBreadcrumbs">
            <template v-slot:item="props">
              <v-breadcrumbs-item
                :disabled="props.item.disabled"
                :class="{
                  'ApuracaoContrato_breadcrumbs-item': true,
                  'ApuracaoContrato_breadcrumbs-item_disabled': props.item.disabled,
                }">
                {{ props.item.text }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="1" class="text-right" v-if="exibirFiltro">
          <v-badge
              bordered
              color="orange"
              icon="mdi-lock"
              overlap
              v-show="!abrirFiltro"
              v-if="habilitarIconBadge">
              <v-icon v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
          </v-badge>
          <v-icon v-else v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
        </v-col>
      </v-row>
    </v-container>

    <apuracao-contrato-filtros
      ref="filtrosComplementares"
      v-model="abrirFiltro"
      :desabilita-aplicar="desabilitaAplicar"
      :filtros-complementares="filtrosComplementares"
      @ApuracaoContratoFiltros__AplicaFiltros="aplicarFiltros"
      @ApuracaoContratoFiltros_conteinerCarregado="abrirTooltip"
      @FiltroRapido__HabilitaIconBadge="habilitaIconBadge"
      @ApuracaoContratoFiltros__setaIdContratoTipo="setaIdContratoTipo">
    </apuracao-contrato-filtros>

    <apuracao-contrato-filtros-obrigatorios
      :id-contrato-tipo="idContratoTipo"
      @ApuracaoContratoFiltrosObrigatorios__AplicaFiltros="aplicarFiltrosObrigatorios"
      @ApuracaoContratoFiltrosObrigatorios__FiltrosObrigatoriosPreenchidos="filtrosObrigatoriosPreenchidos"
    />
    <div class="card-title ml-12 mt-1" style="font-size: 14px; font-weight:normal;">
      {{ $t('message.filtrar_apuracao_contrato') }}
    </div>

    <v-card style="width: 95%;" class="ml-8 mt-10">
      <v-tabs
      align-with-title
      optional
      v-model="tabSelecionada"
      :disabled="desabilitaAplicar"
      @change="clickTab">

        <v-tab href="#tab-apuracao-previa" :disabled="desabilitaAplicar"  background-color="cyan">
          {{ `${$tc('label.apuracao_previa', 2)} (${totalizadoresAbas.apuracaoPrevia})` }}
        </v-tab>
        <v-tab href="#tab-aguardando-apuracao" :disabled="desabilitaAplicar">
          {{ `${$tc('label.aguardando_apuracao', 2)} (${totalizadoresAbas.aguardandoApuracao})`}}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabSelecionada">
        <v-tab-item id="tab-apuracao-previa">
          <apuracao-contrato-tabela
            ref="tab-apuracao-previa"
            :tab="'tab-apuracao-previa'"
            :apuracoes="apuracoes"
            :total-page="totalPage"
            :selecionar-item="selecionarItem"
            :filtros="filtros"
            @ApuracaoContratoTabData__cancelaApuracaoListaSelecionada="cancelaApuracaoListaSelecionada"
            @ApuracaoContratoTabela__AplicaFiltros="aplicarFiltrosObrigatorios"
            v-show="tabSelecionada === 'tab-apuracao-previa'"/>
        </v-tab-item>

        <v-tab-item id="tab-aguardando-apuracao">
          <apuracao-contrato-tabela
            ref="tab-aguardando-apuracao"
            :tab="'tab-aguardando-apuracao'"
            :apuracoes="apuracoes"
            :total-page="totalPage"
            :selecionar-item="selecionarItem"
            :filtros="filtros"
            @ApuracaoContratoTabData__cancelaApuracaoListaSelecionada="cancelaApuracaoListaSelecionada"
            @ApuracaoContratoTabela__AplicaFiltros="aplicarFiltrosObrigatorios"
            v-show="tabSelecionada === 'tab-aguardando-apuracao'"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-container pt-6 fluid v-resize="onResize">
    <v-row v-if="exibirBotoesFinalizar">
      <v-footer
          class="pt-6"
          v-bind="{fixed: true}"
          :style="`width: ${tamanhoRodape}px; background-color: #EEEEEE; min-height: 80px;`"
      >
        <v-spacer v-if="!xs"></v-spacer>
        <div v-if="indExibirApuracoesZeradas">
          <v-btn class="mr-2 my-auto"
            v-if="indCancelarOuFinalizarSelecionados"
            @click="cancelarSelecionados(botaoCancelarSelecionados)">
            {{ $t('label.cancelar_selecionados') }} {{ apuracoesSelecionadas.length }}
          </v-btn>

          <v-tooltip v-if="apuracoes.length" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-15 my-auto mr-3"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="cancelarTudo">
                {{ $t('label.cancelar_tudo') }} {{ apuracoes.length }}
              </v-btn>
            </template>
            <span>{{ $t('message.cancelar_todos_registros_da_pagina')}}</span>
          </v-tooltip>
        </div>
        <div v-else>
          <v-btn class="mr-2 my-auto"
            v-if="indCancelarOuFinalizarSelecionados"
            @click="finalizarSelecionados">
            {{ $t('label.finalizar_selecionados') }}
          </v-btn>
          <v-tooltip v-if="apuracoes.length" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-15 my-auto mr-3"
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="finalizarTudo">
                {{ $t('label.finalizar_tudo') }}
              </v-btn>
            </template>
            <span>{{ $t('message.finalizar_todos_registros_da_pagina') }}</span>
          </v-tooltip>
        </div>
      </v-footer>
    </v-row>
    </v-container>

    <dialog-finalizar-apuracoes
      ref="modalFinalizarApuracoes"
      :apuracoes-inconsistentes="apuracoesInconsistentes"
      @agree="finalizarApuracoesIntegral"
      @cancelar="cancelarFinalizarTudo">
  </dialog-finalizar-apuracoes>

    <v-dialog v-model="dialogCancelamento" persistent max-width="650px">
    <v-card>
      <v-card-title class="pl-3">
          <span class="text-h6 font-weight-bold text-uppercase">
            {{ $t('title.cancelar_apuracoes') }}
          </span>
      </v-card-title>

      <v-row class="px-3">
        <v-col cols="12" class="pt-2">
          <span class="text-body-2">
            <strong>{{ $t('label.atencao') }}:</strong>
            {{ $t('message.confirmacao_apuracoes_selecionadas_para_cancelamento') }}
          </span>
        </v-col>

        <v-col cols="12" class="pt-2">
          <span v-html="`${$t('label.total_de_apuracoes_a_serem_canceladas')}`" class="text-body-2" ></span>
          <b>{{ this.indCancelarTodasApuracoes ? apuracoes.length: apuracoesSelecionadas.length }}</b>
        </v-col>

        <v-col cols="12" class="pt-0">
          <span class="text-body-2">
            {{ $t('label.informe_justificativa') }}:
          </span>
        </v-col>

        <v-col cols="12" class="pt-0">
          <span class="text-body-2 d-block text-decoration-underline">
            {{ $t('label.apuracoes_sem_valor_para_arrecadacao') }}
          </span>
          <span class="caption grey--text">
            {{ $t('message.todos_registros_com_justificativa_cancelamento') }}
          </span>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click="fechaModalCancelamento()">
          {{ $t('label.cancelar') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="confirmarCancelamentoApuracoes()"
        >
          {{ $t('label.ok') }} ({{ this.indCancelarTodasApuracoes ? apuracoes.length: apuracoesSelecionadas.length }})
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import { forceLoading, forceHideLoading } from '@/common/functions/loading';
import ApuracaoContratoFiltros from '@/spa/apuracao-contrato-epoca/ApuracaoContratoFiltros';
import ApuracaoContratoFiltrosObrigatorios from '@/spa/apuracao-contrato-epoca/ApuracaoContratoFiltrosObrigatorios';
import ApuracaoContratoTabela from '@/spa/apuracao-contrato-epoca/ApuracaoContratoTabela';
import ApuracaoContratoControleBreadcrumbs from '@/spa/apuracao-contrato-epoca/ApuracaoContratoControleBreadcrumbs';
import DialogFinalizarApuracoes from '@/spa/apuracao-contrato-epoca/modals/DialogFinalizarApuracoes';
import {
  buscarApuracaoFornecedorPorContrato,
  finalizarApuracaoLoteFornecedor,
  buscarTotalizadoresApuracaoEpoca,
} from '@/common/resources/apuracao-contrato';
import {
  formatlastDayOfTheMonth,
} from '@/common/functions/date-utils';

export default {
  name: 'ApuracaoContrato',
  components: {
    ApuracaoContratoFiltros,
    ApuracaoContratoFiltrosObrigatorios,
    ApuracaoContratoTabela,
    DialogFinalizarApuracoes,
  },
  mixins: [ApuracaoContratoControleBreadcrumbs],
  data() {
    return {
      apuracaoAcaoResource: this.$api.apuracaoAcaoEdicao(this.$resource),
      workflowAcaoMagaluResource: this.$api.workflowAcaoMagalu(this.$resource),
      abrirFiltro: false,
      omiteBreadcrumbs: false,
      aplicarFiltroNoCarregamento: true,
      filtros: {},
      filtrosComplementares: {},
      habilitarIconBadge: false,
      showTooltip: false,
      tamanhoFiltros: 0,
      desabilitaAplicar: true,
      indCancelarOuFinalizarTudo: false,
      apuracoes: [],
      totalPage: 0,
      apuracoesSelecionadas: [],
      apuracoesInconsistentes: [],
      pagination: {
        itemsPerPage: 10,
        page: 1,
      },
      tamanhoTela: window.innerWidth,
      ordenacao: '',
      asc: '',
      idContratoTipo: null,
      isEditandoValorBase: false,
      indExibirApuracoesZeradas: false,
      dialogCancelamento: false,
      botaoCancelarTudo: 'cancelar tudo',
      botaoCancelarSelecionados: 'cancelar selecionados',
      indCancelarTodasApuracoes: false,
      indZerarSelecionadas: false,
      tabSelecionada: null,
      totalizadoresAbas: {
        aguardandoApuracao: 0,
        apuracaoPrevia: 0,
      },
    };
  },
  computed: {
    ...generateComputed('APU_CONTR', [
      'canAccessPage',
    ]),
    xs() {
      return this.$vuetify.breakpoint.xs;
    },
    lg() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    tamanhoRodape() {
      return this.tamanhoTela - (this.abrirFiltro && this.lg ? this.tamanhoFiltros : 0);
    },
    existeApuracoesSelecionadas() {
      return this.apuracoesSelecionadas.filter((a) => a.selecionado).length > 0;
    },
    indCancelarOuFinalizarSelecionados() {
      return !this.indCancelarOuFinalizarTudo
        && (this.apuracoesSelecionadas.length);
    },
  },
  watch: {
    exibirFiltro(val) {
      if (val) {
        setTimeout(() => this.$refs.totalizadores.aplicaFiltros(this.filtros),
          3E2);
      }
    },
  },
  methods: {
    ...mapActions('filtros', [
      'setFiltroApuracaoContrato',
      'setFiltroApuracaoContratoNivel1',
    ]),
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    onResize() {
      this.tamanhoTela = window.innerWidth;
    },
    selecionarItem(itemSelecionado, e) {
      if (e) e.stopPropagation();
      const apuracaoSelecionada = this.apuracoesSelecionadas.find((a) => a.idApuracao === itemSelecionado.idApuracao);
      if (apuracaoSelecionada && !apuracaoSelecionada.selecionado) {
        const index = this.apuracoesSelecionadas.findIndex((a) => a.idApuracao === itemSelecionado.idApuracao);
        this.apuracoesSelecionadas.splice(index, 1);
      }
      if (itemSelecionado.selecionado) {
        this.apuracoesSelecionadas.push(itemSelecionado);
      }
    },
    cancelaApuracaoListaSelecionada(idApuracao) {
      this.apuracoesSelecionadas = this.apuracoesSelecionadas.filter((a) => a.idApuracao !== idApuracao);
    },
    aplicarFiltros(filtrosLaterais, mudouFiltrosLaterais, isBuscaFiltroLateral = false) {
      this.indExibirApuracoesZeradas = this.filtros.indExibirApuracoesZeradas;
      this.filtrosComplementares = filtrosLaterais;

      if (isBuscaFiltroLateral) {
        this.pagination.page = 1;
      }

      const paramsApuracoes = this.formatarFiltros(this.filtros, this.filtrosComplementares, false);
      paramsApuracoes.asc = this.asc;
      paramsApuracoes.colunaOrdenacao = this.ordenacao;

      if (mudouFiltrosLaterais) {
        this.tabSelecionada = null;
        this.apuracoes = [];
        this.totalPage = 0;
        this.totalizadoresAbas = { aguardandoApuracao: 0, apuracaoPrevia: 0 };

        const paramsTotalizadores = this.formatarFiltros(this.filtros, this.filtrosComplementares, true);
        this.buscarTotalizadores(paramsTotalizadores);
      } else if (this.tabSelecionada) {
        const podeBuscar = (this.tabSelecionada === 'tab-aguardando-apuracao' && this.totalizadoresAbas.aguardandoApuracao !== 0) || (this.tabSelecionada === 'tab-apuracao-previa' && this.totalizadoresAbas.apuracaoPrevia !== 0);

        if (podeBuscar) {
          this.buscarApuracoes(paramsApuracoes);
        } else {
          this.apuracoes = [];
          this.totalPage = 0;
        }
      } else {
        const paramsTotalizadores = this.formatarFiltros(this.filtros, this.filtrosComplementares, true);
        this.buscarTotalizadores(paramsTotalizadores);
      }

      this.abrirFiltro = false;
    },
    aplicarFiltrosObrigatorios(paginationTab, tabSelecionada, zerarSelecionadas = false) {
      this.tabSelecionada = tabSelecionada || '';
      this.apuracoes = [];

      if (zerarSelecionadas) {
        this.apuracoesSelecionadas = [];
        this.indZerarSelecionadas = true;
      } else {
        this.indZerarSelecionadas = false;
      }

      if (paginationTab) {
        this.$refs.filtrosComplementares.setarIsPaginacaoAlterada(true);
        this.pagination = paginationTab;
        if (this.pagination.sortBy && this.pagination.sortBy.length) {
          const { sortBy, sortDesc } = this.pagination;
          this.asc = !sortDesc[0];
          this.ordenacao = this.formatarOrdenacaoPorValor(sortBy);
        }
      } else {
        this.pagination.page = 1;
        this.$refs.filtrosComplementares.setarIsPaginacaoAlterada(false);
      }

      if (!this.desabilitaAplicar) {
        this.$refs.filtrosComplementares.$refs.filtrosRapidos.aplicar();
      }
    },
    filtrosObrigatoriosPreenchidos(filtrosObrigatorios) {
      if (filtrosObrigatorios) {
        this.filtros = filtrosObrigatorios;
        this.desabilitaAplicar = false;
        this.tabSelecionada = '';
      } else if (!filtrosObrigatorios && filtrosObrigatorios !== undefined) {
        this.desabilitaAplicar = true;
      }
      this.apuracoes = [];
      this.totalizadoresAbas = {
        aguardandoApuracao: 0,
        apuracaoPrevia: 0,
      };
    },
    formatarOrdenacaoPorValor(sortBy) {
      if (sortBy && sortBy.length) {
        const valor = sortBy[0];
        if (valor === 'periodoVigencia') {
          return 'dc.data_inicio';
        }
        if (valor === 'qtdProduto') {
          return 1;
        }
        let valorFormatado = valor.replace(/([A-Z])/g, '_$1').toLowerCase();
        valorFormatado = `dc.${valorFormatado}`;
        return valorFormatado;
      }
      return null;
    },
    abrirTooltip() {
      setTimeout(() => {
        this.showTooltip = true;
      }, 1000);
      this.tamanhoFiltros = document.getElementById('ApuracaoFiltros__filtro_rapido').offsetWidth;
    },
    buscarApuracoes(params) {
      if (this.indZerarSelecionadas) {
        this.apuracoesSelecionadas = [];
      }
      return buscarApuracaoFornecedorPorContrato(params, this.$resource)
        .then((response) => {
          this.asc = '';
          this.ordenacao = '';
          this.apuracoes = response.data.resposta || [];
          this.totalPage = response.data.quantidadeRegistrosPagina;
          if (!this.indZerarSelecionadas) {
            this.montarSelecionados();
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarTotalizadores(params) {
      return buscarTotalizadoresApuracaoEpoca(params, this.$resource)
        .then((response) => {
          const total = response.data;
          this.totalizadoresAbas = this.formatarTotalizadores(total);
          this.tabSelecionada = 'tab-aguardando-apuracao';
          if (total.total_aguardando_apuracao !== 0 && this.tabSelecionada === 'tab-aguardando-apuracao') {
            setTimeout(() => {
              this.buscarApuracoes(this.formatarFiltros(this.filtros, this.filtrosComplementares, false));
            }, 200);
          }
          if (total.total_apuracao_previa !== 0 && this.tabSelecionada === 'tab-apuracao-previa') {
            setTimeout(() => {
              this.buscarApuracoes(this.formatarFiltros(this.filtros, this.filtrosComplementares, false));
            }, 200);
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    formatarTotalizadores(total) {
      const totalizadores = {
        aguardandoApuracao: total.total_aguardando_apuracao || 0,
        apuracaoPrevia: total.total_apuracao_previa || 0,
      };
      return totalizadores;
    },
    habilitaIconBadge(valor) {
      this.habilitarIconBadge = valor;
    },
    formatarFiltros(filtros, filtrosComplementares, totalizadores = false) {
      const filtrosFormatados = {
        ...filtrosComplementares,
        id_acao_tipo: filtros.tipoAcao,
        exibir_apuracoes_com_valor_zero: filtros.indExibirApuracoesZeradas,
        data_inicio_apuracao: moment(filtros.dataInicio, 'YYYY-MM').format('YYYY-MM-DD'),
        data_fim_apuracao: formatlastDayOfTheMonth(moment(filtros.dataFim, 'YYYY-MM').format('MM-YYYY'), 'YYYY-MM-DD'),
        ids_categoria: this.extrairIds(filtros.categoria),
        status: this.montarFiltrosStatus(filtrosComplementares, totalizadores),
        tamanhoPagina: this.pagination.itemsPerPage,
        numeroPagina: this.pagination.page,
        is_apuracao_epoca: true,
        id_contrato_tipo: this.idContratoTipo,
      };
      return filtrosFormatados;
    },
    montarFiltrosStatus(filtrosComplementares, totalizadores = false) {
      if (totalizadores) {
        return [
          ...(filtrosComplementares && filtrosComplementares.apresentar_apuracoes_finalizadas ? ['APROVADO'] : []),
          ...(filtrosComplementares && filtrosComplementares.apresentar_apuracoes_canceladas ? ['CANCELADO'] : []),
        ];
      }

      if (this.tabSelecionada === 'tab-apuracao-previa') {
        return ['APURACAO_PREVIA'];
      }

      return [
        'AGUARDANDO_APURACAO',
        ...(filtrosComplementares && filtrosComplementares.apresentar_apuracoes_finalizadas ? ['APROVADO'] : []),
        ...(filtrosComplementares && filtrosComplementares.apresentar_apuracoes_canceladas ? ['CANCELADO'] : []),
      ];
    },
    extrairIds(array) {
      if (!array.length) {
        return null;
      }
      return array.map((el) => el.id);
    },
    async finalizarTudo() {
      this.indFinalizarTudo = true;
      this.apuracoesSelecionadas = this.apuracoes;
      await this.finalizarSelecionados();
    },
    finalizarSelecionados() {
      this.apuracoesInconsistentes = [];

      this.apuracoesSelecionadas.forEach((a) => {
        if (this.apuracaoPossuiInconsistencia(a)) {
          this.apuracoesInconsistentes.push(a);
        }
      });
      this.apuracoesSelecionadas = this.apuracoesSelecionadas.filter((a) => !this.apuracaoPossuiInconsistencia(a) && a.statusApuracao !== 'APROVADO');
      setTimeout(() => this.$refs.modalFinalizarApuracoes.open(this.apuracoesSelecionadas));
    },
    finalizarApuracoesIntegral() {
      forceLoading();
      const filtros = this.prepararParametros();
      finalizarApuracaoLoteFornecedor(filtros, this.$resource)
        .then(() => {
          this.aplicarFiltrosObrigatorios();
          this.indFinalizarTudo = false;
          this.apuracoesSelecionadas = [];
          this.$refs.modalFinalizarApuracoes.close();
          this.$toast(this.$tc('message.apuracao_finalizada_sucesso', 2));
          forceHideLoading();
        })
        .catch((err) => {
          forceHideLoading();
          this.$error(this, err);
          this.indFinalizarTudo = false;
          this.apuracoesSelecionadas = [];
          this.$refs.modalFinalizarApuracoes.close();
        });
    },
    prepararParametros() {
      const filtros = { ...this.filtros, ...this.filtrosComplementares };
      if (this.apuracoesSelecionadas.length) {
        const idsApuracao = [];

        this.apuracoesSelecionadas.forEach((apuracao) => {
          if (apuracao.selecionado || this.indFinalizarTudo) {
            idsApuracao.push(Number(apuracao.idApuracao));
          }
        });
        filtros.apuracoesSelecionadas = idsApuracao;
        filtros.apuracoesFornecedores = [];
      }
      filtros.idTipoAcao = [filtros.tipoAcao];
      filtros.idGrupoFornecedor = filtros.id_grupo_fornecedor;
      filtros.status = ['AGUARDANDO_APURACAO'];

      delete filtros.tipoAcao;
      delete filtros.id_grupo_fornecedor;
      delete filtros.dataInicio;
      delete filtros.dataFim;
      delete filtros.grupo_fornecedor;
      delete filtros.categoria;
      delete filtros.numeroPagina;
      delete filtros.tamanhoPagina;

      return filtros;
    },
    apuracaoPossuiInconsistencia(apuracao) {
      return (apuracao.indJustificativa && !apuracao.justificativaAlterarRecebimento)
      || (typeof apuracao.vlrRealizado === 'undefined' || apuracao.vlrRealizado === '')
      || !apuracao.existeAtingimento;
    },
    setaIdContratoTipo(idContratoTipo) {
      this.idContratoTipo = idContratoTipo;
    },
    cancelarFinalizarTudo() {
      this.indFinalizarTudo = false;
      this.apuracoesSelecionadas = [];
    },
    async cancelarTudo() {
      await this.cancelarSelecionados(this.botaoCancelarTudo);
    },
    cancelarSelecionados(botaoSelecionado) {
      if (botaoSelecionado === this.botaoCancelarTudo) {
        this.indCancelarTodasApuracoes = true;
      }
      setTimeout(this.dialogCancelamento = true);
    },
    fechaModalCancelamento() {
      this.indCancelarSelecao = false;
      this.indCancelarTodasApuracoes = false;
      this.dialogCancelamento = false;
    },
    confirmarCancelamento() {
      this.fechaModalCancelamento();
    },
    confirmarCancelamentoApuracoes() {
      if (this.indCancelarTodasApuracoes) {
        this.apuracoesSelecionadas = this.apuracoes;
      }
      const listaIdsApuracao = this.apuracoesSelecionadas.map((apuracao) => apuracao.idApuracao);
      const justificativaCancelamento = this.$tc('label.apuracoes_sem_valor_para_arrecadacao');

      this.apuracaoAcaoResource.cancelarApuracoes({ justificativaCancelamento }, listaIdsApuracao)
        .then(() => {
          listaIdsApuracao.forEach((idApuracao) => {
            const index = this.apuracoes.findIndex((a) => a.idApuracao === idApuracao);
            this.apuracoes.splice(index, 1);
          });
          this.$toast(this.$t('message.apuracao_cancelada_sucesso'));
          this.apuracoesSelecionadas = [];
          this.fechaModalCancelamento();
          const nomRef = this.$refs.tabs.tabSelecionada;
          this.$refs.tabs.$refs[nomRef].reRenderizarTable();
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    clickTab() {
      this.aplicarFiltrosObrigatorios(this.pagination, this.tabSelecionada, true);
      if (this.apuracoes.length) {
        this.resetarPaginationTabs(this.tabSelecionada);
      }
    },
    resetarPaginationTabs(tab) {
      setTimeout(() => this.$refs[tab].resetarPagination(), 2E2);
    },
    montarSelecionados() {
      this.apuracoes.forEach((apuracao) => {
        const apuracaoSelecionada = this.apuracoesSelecionadas.find((a) => a.idApuracao === apuracao.idApuracao);
        if (apuracaoSelecionada) {
          apuracao.selecionado = true;
        }
      });
    },
    exibirBotoesFinalizar() {
      return !this.isEditandoValorBase || this.tabSelecionada !== 'tab-apuracao-previa';
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};
</script>
<style lang="scss">
.ApuracaoContrato_breadcrumbs-item_disabled {
  color: grey;
  pointer-events: none;
}
.ApuracaoContrato_breadcrumbs-item {
  color: grey;
  cursor: pointer;
}
.ApuracaoContrato_breadcrumbs-item:hover {
  color: #3f3f3f;
}
</style>
